<template>
  <v-textarea
    v-bind="field"
    v-model="toEditVal"
    :label="label"
    :rules="rules"
    :disabled="disabled || readOnly"
    :rows="disabled && (!toEditVal || toEditVal.length < 20) ? 1 : 4"
    @change="$emit('update:toEdit', toEditVal)"
  />
</template>

<script>

export default {
  name: 'TextAreaField',
  props: {
    field: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    rules: {
      type: Array,
      default: () => []
    },
    // eslint-disable-next-line vue/require-prop-types
    toEdit: {
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      toEditVal: this.toEdit
    }
  },
  watch: {
    toEdit () {
      this.toEditVal = this.toEdit
    }
  }
}
</script>

<style scoped>

</style>
